import {useEffect, useState} from 'react';

export const useNetworkStatus = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [isSlow, setIsSlow] = useState(false);

  useEffect(() => {
    const offlineListener = () => setIsOffline(true);
    const onlineListener = () => setIsOffline(false);
    const customSlowNetworkConnectionListener = () => setIsSlow(true);
    const customFastNetworkConnectionListener = () => setIsSlow(false);

    window.addEventListener('offline', offlineListener);
    window.addEventListener('online', onlineListener);
    window.addEventListener('customSlowNetworkConnection', customSlowNetworkConnectionListener);
    window.addEventListener('customFastNetworkConnection', customFastNetworkConnectionListener);

    return () => {
      window.removeEventListener('offline', offlineListener);
      window.removeEventListener('online', onlineListener);
      window.removeEventListener('customSlowNetworkConnection', customSlowNetworkConnectionListener);
      window.removeEventListener('customFastNetworkConnection', customFastNetworkConnectionListener);
    };
  }, []);

  return {isOffline, isSlow};
};
